__webpack_require__.p = "https://js-static.iimjobs.com/production/6.2.0/_next/";